exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".table th,td{font-size:14px}", "", {"version":3,"sources":["D:/app/gocode/src/gitlab.com/satit13/VillageService/ui/src/views/reportincomeusermonth.vue"],"names":[],"mappings":"AACA,aAEE,cAAgB,CACjB","file":"reportincomeusermonth.vue","sourcesContent":["\n.table th,\r\ntd {\r\n  font-size: 14px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38ea5ef2","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/reportincomeusermonth.vue
// module id = 409
// module chunks = 15